import { createAction, props } from "@ngrx/store";
// import { UserCreateDTO } from 'src/app/models/UserDetails/userCreateDTO';
// import { UserUpdateDTO } from 'src/app/models/UserDetails/userUpdateDTO';

export const resetFuelStocksState = createAction(
  "[FuelStock] Reset Fuel Stocks State Action"
);
export const getFuelStocks = createAction(
  "[FuelStock] Get All Fuel Stocks Action",
  props<{ options: any }>()
);
export const loadFuelStocks = createAction(
  "[FuelStock] Load All Fuel Stock Action",
  props<{ response: any[] }>()
);
export const loadFuelStocksFailure = createAction(
  "[FuelStock] Fuel Stocks Load Action Failure",
  props<{ error: Error }>()
);
export const updateFuelStock = createAction(
  "[FuelStock] Update Fuel Stock Action",
  props<{ fuelStock: any }>()
);
export const getFuelStock = createAction(
  "[FuelStock] Get Fuel Stock Action",
  props<{ fuelStock: any }>()
);
export const setFuelStock = createAction(
  "[FuelStock] Set Fuel Stock Action",
  props<{ response: any }>()
);

export const getLastMeasurements = createAction(
  "[FuelStock] Get Last Measurements Action",
  props<{ code: any }>()
);
export const setLastMeasurements = createAction(
  "[FuelStock] Set Last Measurements Action",
  props<{ result: any }>()
);
export const getLastDeliveries = createAction(
  "[FuelStock] Get Last Deliveries Action",
  props<{ code: any }>()
);
export const setLastDeliveries = createAction(
  "[FuelStock] Set Last Deliveries Action",
  props<{ result: any }>()
);
export const getFuelStockExcelList = createAction(
  "[FuelStock] Get All FuelStock Excel List Action",
  props<{ options: any }>()
); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadFuelStockExcelList = createAction(
  "[FuelStock] Load All FuelStock Excel List Action",
  props<{ response: any[] }>()
);

// Fuel Stocks Table Configuration Settings
export const getFuelStockTableConfig = createAction(
  "[FuelStock] Get Fuel Stock Table Configuration Action",
  props<{ options: any }>()
);
export const loadFuelStockTableConfig = createAction(
  "[FuelStock] Load Fuel Stock Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveFuelStockTableConfig = createAction(
  "[FuelStock] Save Fuel Stock Table Configuration Action",
  props<{ config: any }>()
);

// Fuel Stocks Movements Table Configuration Settings
export const getFuelStockMovementsTableConfig = createAction(
  "[FuelStock] Get Fuel Stock Movements Table Configuration Action",
  props<{ options: any }>()
);
export const loadFuelStockMovementsTableConfig = createAction(
  "[FuelStock] Load Fuel Stock Movements Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveFuelStockMovementsTableConfig = createAction(
  "[FuelStock] Save Fuel Stock Movements Table Configuration Action",
  props<{ config: any }>()
);

// export const changeStatus = createAction('[FuelStock] Change Fuel Stock Status Action', props<{ usernames: any[], enabled: any }>());
export const createFuelStock = createAction(
  "[FuelStock] Create Fuel Stock Action",
  props<{ fuelStock: any }>()
);
export const loadFuelStocksLoadStart = createAction(
  "[FuelStock] Load Start Action"
);
export const loadFuelStocksLoadEnd = createAction(
  "[FuelStock] Load End Action"
);
export const resetFuelStock = createAction(
  "[FuelStock] Reset FuelStock Action"
);
export const resetCreation = createAction("[FuelStock] Reset Creation Action");
export const getStockStats = createAction(
  "[FuelStock] Get Stock Stats Action",
  props<{ code: any }>()
);
export const loadStockStats = createAction(
  "[FuelStock] Load Stock Stats Action",
  props<{ result: any }>()
);

export const getFuelStockMovements = createAction(
  "[FuelStock] Get FuelStock Movements Action",
  props<{ options: any }>()
);
export const loadFuelStockMovements = createAction(
  "[FuelStock] Load FuelStock Movements Action",
  props<{ response: any }>()
);

export const setLoadingEndState = createAction("[FuelStock] Load End Action");
